export default "__VITE_ASSET__BMaEiw0O__"